import { useEffect, FC } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import UsuarioLogadoProvider, { IdTokenParsed } from '../UsuarioLogadoContext/UsuarioLogadoContext';
import { Sentry } from 'service/Sentry';
import { useDispatch, useSelector } from 'react-redux';
import { AutorizacaoSelector } from 'store/Autorizacao/Autorizacao.selector';
import { AutorizacaoAction } from 'store/Autorizacao/Autorizacao.action';


export const AutorizacaoProvider: FC = (props) => {
  const {keycloak} = useKeycloak();

  if (!hasToken(keycloak)) {
    return <></>
  }

  Sentry.instance.atualizarDados(keycloak);

  return (
    <ContainerComKeycloakComToken>
      {props.children}
    </ContainerComKeycloakComToken>
  )
}


// FIXME - Procurar modo mais elegante de fazer isso
const ContainerComKeycloakComToken: FC = (props) => {
  const dispatch = useDispatch();

  const ocioso = useSelector(AutorizacaoSelector.isOcioso);

  useEffect(() => {
    if (ocioso) {
      dispatch(AutorizacaoAction.iniciar());
    }
  }, [dispatch, ocioso]);

  return <UsuarioLogadoProvider>
    {props.children}
  </UsuarioLogadoProvider>
}


function hasToken(keycloak: Keycloak.KeycloakInstance) {
  const idTokenParsed = keycloak.idTokenParsed as IdTokenParsed|undefined;
  return keycloak.token !== undefined && idTokenParsed?.id_institucional !== undefined;
}